import moment from "moment";

export const adaptDatosGeneralesRIResumen = (data) => {
    const { datosGeneralesRINavigation, datosFiliatorios } = data;

    const {
        tipoModuloRI,
        diagnosticoRI,
        antecedenteClinicoRI,
        alergiaRI,
        requerimientosExtraNutricionalesRI,
        justificacionSoporteRI,
        idComboRIValorLugarRINavigation,
        idComboRIValorLugarServicioNavigation,
        codInstitucionReferenciaNavigation,
        idComboRIValorNivelActividadNavigation,
        idComboRIValorAduPerdidaPesoNavigation,
        idComboRIValorAduGradoDesnutricionNavigation,
        idComboRIValorAduDiagnosticoNutricionalNavigation,
        idComboRIValorAduMetaNutricionalNavigation,
        idComboRIValorPedDiagnosticoNutricionalNavigation,
        idComboRIValorPedMetaSoporteNutricionalNavigation,
        idComboRIValorAduEvaluadoNavigation,
        ...datosGenerales
    } = datosGeneralesRINavigation;

    const { fechaNacimiento, edad, ...otherDatosFiliatorios } = datosFiliatorios;

    return {
        ...datosGenerales,
        ...otherDatosFiliatorios,
        selectedPrograms: tipoModuloRI?.map(x => x.idTipoModulo),
        selectedProgramNames: tipoModuloRI?.map(x => ({ id: x.idTipoModulo, displayName: x.idTipoModuloNavigation.abreviacion })),
        diagnosticosRI: diagnosticoRI?.map(x => (x.idItemDiagnosticoNavigation.descripcion ?? x.idItemDiagnostico)),
        antecedentesClinicos: antecedenteClinicoRI.map(x => x.idComboRIValorNavigation?.valor),
        alergias: alergiaRI.map(x => x?.idAlergiaNavigation?.descripcion),
        requerimientosExtraNutricionalesRI: requerimientosExtraNutricionalesRI.map(x => x.idComboRIValorNavigation?.valor),
        justificacionSoporteRI: justificacionSoporteRI.map(x => x.idComboRIValorNavigation?.valor),
        comboRIValorLugarRI: idComboRIValorLugarRINavigation?.valor,
        comboRIValorLugarServicio: idComboRIValorLugarServicioNavigation?.valor,
        codInstitucionReferencia: codInstitucionReferenciaNavigation?.nombre,
        idComboRIValorNivelActividad: idComboRIValorNivelActividadNavigation?.valor,
        idComboRIValorAduPerdidaPeso: idComboRIValorAduPerdidaPesoNavigation?.valor,
        idComboRIValorAduGradoDesnutricion: idComboRIValorAduGradoDesnutricionNavigation?.valor,
        idComboRIValorAduDiagnosticoNutricional: idComboRIValorAduDiagnosticoNutricionalNavigation?.valor,
        idComboRIValorAduMetaNutricional: idComboRIValorAduMetaNutricionalNavigation?.valor,
        idComboRIValorPedDiagnosticoNutricional: idComboRIValorPedDiagnosticoNutricionalNavigation?.valor,
        idComboRIValorPedMetaSoporteNutricional: idComboRIValorPedMetaSoporteNutricionalNavigation?.valor,
        idComboRIValorAduEvaluado: idComboRIValorAduEvaluadoNavigation?.valor,


        fechaNacimiento: moment(fechaNacimiento).format('DD-MM-YYYY'),
        edadAnios: moment().diff(moment(fechaNacimiento), 'years'),
    }
}
